import { gql } from '@apollo/client';

export const GET_THEME = gql`
  query GetTheme($tenantId: String!, $type: String!) {
    theme(tenantId: $tenantId, type: $type)
      @rest(
        type: "Theme"
        path: "/theme?tenantId={args.tenantId}&type={args.type}"
        method: "GET"
      ) {
      id
      tenantId
      type
      primaryBrandColor
      primaryBrandColor10
      primaryBrandColor20
      primaryBrandColor30
      primaryBrandColor40
      primaryBrandColor50
      primaryBrandColor60
      primaryBrandColor70
      primaryBrandColor80
      primaryBrandColor90
      primaryBrandColor100
      secondaryBrandColor
      secondaryBrandColor10
      secondaryBrandColor20
      secondaryBrandColor30
      secondaryBrandColor40
      secondaryBrandColor50
      secondaryBrandColor60
      secondaryBrandColor70
      secondaryBrandColor80
      secondaryBrandColor90
      secondaryBrandColor100
      actionColor
      actionColor10
      actionColor20
      actionColor30
      actionColor40
      actionColor50
      actionColor60
      actionColor70
      actionColor80
      actionColor90
      actionColor100
      backgroundColor
      navBackgroundColor
      textDarkColor
      textLightColor
      subtleTextColor
      subtleTextColor10
      subtleTextColor20
      subtleTextColor30
      subtleTextColor40
      subtleTextColor50
      subtleTextColor60
      subtleTextColor70
      subtleTextColor80
      subtleTextColor90
      subtleTextColor100
      successColor
      successColor15
      warningColor
      warningColor15
      errorColor
      errorColor15
      errorColor50
      primaryFont
      fontSize
      logoUrl
      faviconUrl
    }
  }
`;
